"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Form = /*#__PURE__*/function () {
  function Form(selector) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Form);
    _defineProperty(this, "defaultValidations", {
      text: function text(field) {
        var value = field.value.trim();
        if (!value) return "Feltet er påkrævet";
        if (value.length <= 1) return "Indtast venligst mere end 1 karakter";
        return false;
      },
      tel: function tel(field) {
        var value = field.value.trim();
        if (!value) return "Telefonnummer påkrævet";
        value = value.replace(/\D/g, "");
        if (![8, 10, 12].includes(value.length)) return "Ugyldigt telefonnummer";
        return false;
      },
      email: function email(field) {
        var value = field.value.trim();
        if (!value) return "Email påkrævet";
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(value)) return "Ugyldig email";
        return false;
      },
      checkbox: function checkbox(field) {
        var checked = field.checked;
        if (!checked) return "Du skal acceptere vilkårene";
        return false;
      }
    });
    this.form = document.querySelector(selector);
    if (!this.form) {
      console.error("Couldn't find form with selector:", selector);
      return;
    }
    this.hasInteracted = false;
    this.sms = options.sms === "true";
    this.email = options.email === "true";
    this.fields = Array.from(this.form.elements);
    this.fields.forEach(function (field) {
      ["input", "blur", "focus"].forEach(function (eventType) {
        field.addEventListener(eventType, function () {
          if (!_this.hasInteracted) {
            _this.hasInteracted = true;
            if (typeof Bugsnag !== "undefined") {
              Bugsnag.leaveBreadcrumb("Interacted with form ID: ".concat(_this.form.id));
            }
          }
          _this.validateField(field, eventType, false);
        });
      });
    });
    this.validations = options.validations || this.defaultValidations;
    this.onSubmit = options.onSubmit || this.defaultSubmitHandler.bind(this);
    this.errorHandler = options.errorHandler || this.defaultErrorHandler;
    this.form.addEventListener("submit", function (e) {
      return _this.handleSubmit(e);
    });
  }

  // Default error handler
  return _createClass(Form, [{
    key: "defaultErrorHandler",
    value: function defaultErrorHandler(field, message) {
      var parentElement = field.parentElement;
      var insideInputContainer = parentElement.classList.contains("input-container");
      if (insideInputContainer) {
        parentElement.classList.add("input-error");
        parentElement.classList.remove("input-valid");
      } else {
        if (field.type === "checkbox" && field.name === "agree") {
          field.nextElementSibling.classList.add("input-error");
          field.nextElementSibling.classList.remove("input-valid");
        } else {
          field.classList.add("input-error");
          field.classList.remove("input-valid");
        }
      }
      var errorElement = insideInputContainer ? field.type === "checkbox" ? parentElement.parentElement.lastElementChild : parentElement.nextElementSibling : field.nextElementSibling;
      if (errorElement && errorElement.classList.contains("input-error-message")) {
        errorElement.textContent = message;
      } else {
        var errorId = "".concat(this.form.id, "-").concat(field.name, "-error");
        var newError = document.createElement("span");
        newError.className = "input-error-message";
        newError.textContent = message;
        newError.id = errorId;
        if (insideInputContainer) {
          //console.log("Inside input container");
          if (field.type === "checkbox") {
            //console.log("Checkbox parent element");
            parentElement.parentElement.appendChild(newError);
          } else {
            parentElement.insertAdjacentElement("afterend", newError);
          }
        } else {
          field.insertAdjacentElement("afterend", newError);
        }
        field.setAttribute("aria-invalid", true);
        field.setAttribute("aria-describedby", "".concat(errorId));
      }
    }

    // Default submit handler
  }, {
    key: "defaultSubmitHandler",
    value: function () {
      var _defaultSubmitHandler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(token) {
        var formDataObject, submitButton, url, response, contentType, responseBody;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //console.log("Submitting form default handler");

              if (typeof Bugsnag !== "undefined") {
                Bugsnag.leaveBreadcrumb("Submitting form ID: ".concat(this.form.id));
              }
              this.clearNotification();
              formDataObject = new FormData(this.form);
              submitButton = this.form.querySelector('button[type="submit"]');
              _context.prev = 4;
              url = this.sms ? "".concat(settings.templateDir, "/post/sms-handler.php") : "".concat(settings.templateDir, "/post/email-handler.php");
              submitButton.disabled = true;
              _context.next = 9;
              return fetch(url, {
                method: "POST",
                body: new URLSearchParams(_objectSpread(_objectSpread({}, Object.fromEntries(formDataObject)), {}, {
                  token: token
                }))
              });
            case 9:
              response = _context.sent;
              if (response.ok) {
                _context.next = 14;
                break;
              }
              // handle
              submitButton.disabled = false;
              this.displayNotification("<b>Der skete en fejl!</b> Prøv venligst igen, ellers kontakt os direkte på telefon eller e-mail. Vi beklager ulejligheden.", "error");
              throw new Error("Submission failed");
            case 14:
              contentType = response.headers.get("content-type");
              if (!(contentType && contentType.includes("application/json"))) {
                _context.next = 21;
                break;
              }
              _context.next = 18;
              return response.json();
            case 18:
              responseBody = _context.sent;
              _context.next = 24;
              break;
            case 21:
              _context.next = 23;
              return response.text();
            case 23:
              responseBody = _context.sent;
            case 24:
              //console.log("Response body:", responseBody);

              this.displayNotification("<b>Tak for din henvendelse!</b> Du vil blive kontaktet af os hurtigst muligt.", "success");
              this.form.querySelectorAll(".input-valid").forEach(function (field) {
                return field.classList.remove("input-valid");
              });
              this.form.reset();
              _context.next = 33;
              break;
            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](4);
              // handle
              submitButton.disabled = false;
              console.error("Submission error:", _context.t0);
            case 33:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 29]]);
      }));
      function defaultSubmitHandler(_x) {
        return _defaultSubmitHandler.apply(this, arguments);
      }
      return defaultSubmitHandler;
    }()
  }, {
    key: "displayNotification",
    value: function displayNotification(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
      //console.log("Displaying notification");
      var notification = this.form.parentElement.querySelector("[role=alert]");
      if (!notification) {
        console.error("Couldn't find notification element");
        return;
      }
      notification.innerHTML = message;
      notification.setAttribute("type", type);
      notification.classList.remove("!hidden");
      var rect = notification.getBoundingClientRect();
      var isOutOfView = rect.bottom < window.innerHeight * 0.5 || rect.top > window.innerHeight * 0.5;
      if (isOutOfView) {
        // console.log("Scrolling into view");
        // console.log(rect.bottom, rect.top, window.innerHeight);
        // console.log(rect.bottom < 0, rect.top > window.innerHeight);
        notification.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      }
    }
  }, {
    key: "clearNotification",
    value: function clearNotification() {
      //console.log("Clearing notification");
      var notification = this.form.parentElement.querySelector("[role=alert]");
      if (!notification) {
        console.error("Couldn't find notification element");
        return;
      }
      notification.classList.add("!hidden");
    }

    // Handle submit
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      //console.log("Handling submit event");
      event.preventDefault();
      if (this.validateForm()) {
        var onSubmit = this.onSubmit;
        grecaptcha.execute(settings.v3public, {
          action: "submit_".concat(this.form.id.replace(/\-/g, "_"))
        }).then(function (token) {
          onSubmit(token);
        });
      }
    }

    // Validate form fields
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this2 = this;
      var isValid = true;
      this.fields.forEach(function (field) {
        var validation = _this2.validations[field.type];
        if (validation) {
          var errorMessage = validation(field);
          if (errorMessage) {
            isValid = false;
            _this2.errorHandler(field, errorMessage);
          } else {
            _this2.clearError(field);
          }
        }
      });
      return isValid;
    }
  }, {
    key: "validateField",
    value: function validateField(field, eventType) {
      var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // console.log(
      //   "Validating field:",
      //   field.name,
      //   "with event:",
      //   eventType,
      //   strict,
      // );

      if (eventType === "input") {
        this.clearError(field);
        return;
      }
      if (!field.hasAttribute("required")) {
        return;
      }
      if (eventType === "focus") {
        return;
      }
      if (eventType === "blur") {
        if (typeof Bugsnag !== "undefined") {
          var _window$consent;
          Bugsnag.leaveBreadcrumb("Blurred input field", {
            formId: this.form.id,
            field: field.name,
            value: (_window$consent = window.consent) !== null && _window$consent !== void 0 && _window$consent.allowStatistics ? field.value : "REDACTED"
          });
        }
      }
      var validation = this.validations[field.type];
      if (validation && (strict || field.value)) {
        var errorMessage = validation(field);
        if (errorMessage) {
          if (typeof Bugsnag !== "undefined") {
            var _window$consent2;
            Bugsnag.leaveBreadcrumb("Input field has error in it", {
              formId: this.form.id,
              errorMessage: errorMessage,
              field: field.name,
              value: (_window$consent2 = window.consent) !== null && _window$consent2 !== void 0 && _window$consent2.allowStatistics ? field.value : "REDACTED"
            });
          }
          this.errorHandler(field, errorMessage);
        } else {
          this.clearError(field);
          var parentElement = field.parentElement;
          var insideInputContainer = parentElement.classList.contains("input-container");
          if (insideInputContainer) {
            parentElement.classList.add("input-valid");
          } else {
            if (field.type === "checkbox" && field.name === "agree") {
              field.nextElementSibling.classList.add("input-valid");
            } else {
              field.classList.add("input-valid");
            }
          }
        }
      }
    }

    // Clear error messages
  }, {
    key: "clearError",
    value: function clearError(field) {
      var parentElement = field.parentElement;
      var insideInputContainer = parentElement.classList.contains("input-container");
      if (insideInputContainer) {
        parentElement.classList.remove("input-error");
      } else {
        if (field.type === "checkbox" && field.name === "agree") {
          field.nextElementSibling.classList.remove("input-error");
        } else {
          field.classList.remove("input-error");
        }
      }
      field.removeAttribute("aria-invalid");
      field.removeAttribute("aria-describedby");
      var errorElement = insideInputContainer ? field.type === "checkbox" ? parentElement.parentElement.lastElementChild : parentElement.nextElementSibling : field.nextElementSibling;
      if (errorElement && errorElement.classList.contains("input-error-message")) {
        errorElement.remove();
      }
    }
  }]);
}();
document.addEventListener("DOMContentLoaded", function () {
  if (window.pendingForms && window.pendingForms.length) {
    window.pendingForms.forEach(function (config) {
      //console.log("Registering form with config:", config);
      if (typeof Bugsnag !== "undefined") {
        Bugsnag.leaveBreadcrumb("Registering form", {
          config: config
        });
      }
      new Form(config.selector, config);
    });

    // Clear pendingForms after registration
    window.pendingForms = [];
  }
});
//# sourceMappingURL=form.js.map